import type { TMessages } from '@/types/TMessages'

export const messages = {
  sectionTitle: 'Лизинг грузовых автомобилей',
  title: 'Любые марки для вашего бизнеса',
  specialOffers: 'Спецпредложения по маркам КамАз, Hino,<br/> Hyundai и другим. Сниженные авансы и скидки',
  expressTruckProgram: {
    title: 'Программа «Экспресс грузовик»',
    text: 'до 5 машин без финансовых документов компании,<br/> оформление от 1 дня',
  },
  button: 'Подать заявку',
} satisfies TMessages
